module.exports = __webpack_public_path__ + "static/media/extension-activity.eb64ea68.md";